import { Link } from '../../models/assignments/Assignments'
import { APP_ROUTE } from '../common/constants/routingConstants'

export enum InfoSheetLinkDestinationKind {
  APP_URL = 'appUrl',
  LINK_URL = 'linkUrl',
}

export type InfoSheetLinkDestination = { kind: InfoSheetLinkDestinationKind; url: string }

const isAppRouteKey = (value: unknown): value is keyof typeof APP_ROUTE =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(APP_ROUTE, value)

export const resolveInfoSheetLinkDestination = (link: Link): InfoSheetLinkDestination | null => {
  if (typeof link.linkUrl === 'string' && link.linkUrl.trim().length > 0) {
    return { kind: InfoSheetLinkDestinationKind.LINK_URL, url: link.linkUrl }
  }

  if (isAppRouteKey(link.appUrl)) {
    return { kind: InfoSheetLinkDestinationKind.APP_URL, url: APP_ROUTE[link.appUrl] }
  }

  return null
}
